import React, { Component } from 'react'

export default class StepQuiz extends Component {
  constructor(props) {
    super(props);

    this.updateResult = this.props.updateResult;

    this.state = { answerValue: this.props.initialResult };
    this.updateResult(
      true
    );
    
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    event.preventDefault();
    const { name, checked } = event.target;
    if (!checked) {
      return;
    }
    const { itemDestinationName } = this.props.options;

    this.updateResult(
      true,
      itemDestinationName,
      name
    );

    const { answerValue } = this.state;
    let answer = answerValue ? answerValue : {};
    answer[itemDestinationName] = name;

    this.setState(() => ({
      answerValue: answer
    }));
  }

  render() {
    const { answerValue } = this.state;
    const {
      possibleChoices,
      itemLabel,
      itemDestinationName
    } = this.props.options;

    const currentAnswer = answerValue && answerValue[itemDestinationName] ? answerValue[itemDestinationName] : possibleChoices[0];
    
    return (
      <div className="tab">
        <div className="question">{itemLabel}</div>
        <div className="radio-labels">
          {possibleChoices.map((option, index) => {
            return (
              <label key={index} className="auto-mt-xs">
                <input
                  className={`${currentAnswer === option ? 'input-radio-checked' : ''}`}
                  onChange={this.handleChange}
                  type="radio"
                  name={option}
                  checked={currentAnswer === option}
                />
                {option}
                <p></p>
              </label>
            );
          })}
        </div>
      </div >
    );
  }
}
